import React, { useState, useRef } from 'react';
import styles from '@styles/components/Components.module.css';

export interface DropdownItem {
    id: string;
    description: string;
}

interface DropdownProps {
    items: DropdownItem[];
    onSelect: (selectedItem: DropdownItem) => void;
    placeholder?: string;
    SvgComponent?: React.FC; // Optional SVG component for the dropdown
    defaultSelection?: DropdownItem
}

const Dropdown: React.FC<DropdownProps> = ({ items, onSelect, placeholder = 'Selecciona una opción'.localized(), SvgComponent, defaultSelection }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState<DropdownItem | null>(defaultSelection);
    const dropdownRef = useRef<HTMLDivElement>(null);

    const handleDropdownClick = () => {
        setIsDropdownOpen(!isDropdownOpen);
        if (dropdownRef.current) {
            dropdownRef.current.scrollTop = 0;
        }
    };

    const handleItemClick = (item: DropdownItem) => {
        setSelectedItem(item);
        setIsDropdownOpen(false);
        onSelect(item);
    };

    return (
        <div className={styles['dropdown-container']}>
            <div className={styles['dropdown']} onClick={handleDropdownClick}>
                <div className={styles['dropdown-option']}>
                    {SvgComponent && (
                        <div className={styles['svg-container']} style={{ width: '30px', marginRight: '5px' }}>
                            <SvgComponent />
                        </div>
                    )}
                    <p className={styles['dropdown-text']}>
                        {selectedItem ? selectedItem.description : placeholder}
                    </p>
                </div>
                <div className={styles['svg-container']}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14"
                        height="8"
                        viewBox="0 0 14 8"
                        fill="none"
                        style={{
                            transform: isDropdownOpen ? 'rotate(180deg)' : 'none',
                            transition: 'transform 0.2s ease',
                        }}
                    >
                        <path
                            d="M1 1L7 7L13 1"
                            stroke="#666666"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>
            <div
                ref={dropdownRef}
                className={styles['dropdown-expanded-container']}
                style={{
                    overflowY: isDropdownOpen ? 'auto' : 'hidden',
                    maxHeight: '200px', // Set the maximum height
                    height: isDropdownOpen ? 'auto' : '0', // Use 'auto' to adjust height dynamically
                    transition: 'height 0.2s ease-out',
                    pointerEvents: isDropdownOpen ? 'auto' : 'none',
                    opacity: isDropdownOpen ? '1' : '0',
                }}
            >
                {items.map((item) => (
                    <div
                        key={item.id}
                        className={styles['dropdown-option']}
                        onClick={() => handleItemClick(item)}
                    >
                        <div className={styles['dropdown-option']}>
                            {SvgComponent && (
                                <SvgComponent />
                            )}
                            <p className={styles['dropdown-text']}>{item.description}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Dropdown